<template>
    <el-table
        :data="data"
        ref="table"
        :empty-text="emptyText"
        class="tax-data-table payment"
        v-loading="isLoading"
        :default-sort="{ prop: 'foO_DAT', order: 'ascending' }"
        :height="tableHeight"
        :key="tableKey"
        @select="onSelect"
        @select-all="onSelectAll"
        @sort-change="onSortChange"
    >
        <el-table-column key="index" fixed label="#" type="index" :index="getIndex" width="60" class-name="td_index"></el-table-column>
        <el-table-column key="selection" fixed type="selection" width="45" :selectable="isExportable" :show-overflow-tooltip="false"></el-table-column>
        <el-table-column prop="declareStatus" label="申報狀態" width="100" sortable>
            <template slot-scope="scope">
                <span class="declare-status">
                    <span>{{ getDeclaredText(scope.row) }}</span>
                </span>
            </template>
        </el-table-column>
        <el-table-column key="period" prop="period" label="申報期別" width="160" v-if="showPeriod">
            <template slot-scope="scope">
                <div v-if="isStatusChangeable(scope.row) && scope.row.prefiX_MONTH">
                    {{ getPeriodText(scope.row.prefiX_YER, scope.row.prefiX_MONTH) }}
                </div>
            </template>
        </el-table-column>
        <el-table-column key="foO_DAT" prop="foO_DAT" label="單據日期" width="105" sortable>
            <template slot-scope="scope">
                <div>
                    {{ scope.row.foO_DAT | dateFormater("YYYY-MM-dd") }}
                </div>
            </template>
        </el-table-column>
        <el-table-column key="typ" prop="typ" label="單據類型" align="left" min-width="120" sortable>
            <template slot-scope="scope">
                <div>
                    {{ getAttachmentTextByKey(scope.row.filE_TYP) }}
                    <el-tooltip v-if="!onCheckType(scope.row)" effect="dark" placement="top" content="單據類型選擇錯誤">
                        <span class="icon el-icon-warning" style="display: inline-block; color: #ffba00; margin-left: 5px"></span>
                    </el-tooltip>
                </div>
            </template>
        </el-table-column>
        <el-table-column key="foo" prop="foo" label="單據號碼" width="115" sortable>
            <template slot-scope="scope">
                <div style="font-weight: bold">
                    <ahReceiptNumber :v="scope.row.foo" />
                </div>
                <div v-if="checkNumberDuplicate(scope.row)" class="duplicate-item">重複</div>
            </template>
        </el-table-column>
        <el-table-column key="code" prop="code" label="格式代號" width="130">
            <template slot="header">格式代號</template>
            <template v-if="scope.row.typ !== 1" slot-scope="scope">
                <div v-if="isStatusChangeable(scope.row)" style="display: flex; align-items: center">
                    <el-select
                        :value="Number(scope.row.code)"
                        size="mini"
                        placeholder="請選擇"
                        style="width: 90px"
                        :disabled="!isCodeAvailable(scope.row)"
                        @input="onItemCodeInput(scope.row.sno, $event, scope.row.taxCredited)"
                    >
                        <el-option v-for="item in codeOptions" :key="item.value" :label="item.label" :value="item.value">
                            <span style="margin-bottom: 0; padding-right: 15px">{{ item.label }}</span>
                            <span style="color: #8492a6; font-size: 13px; margin-top: -10px">{{ item.info }}</span>
                        </el-option>
                    </el-select>
                    <el-tooltip v-if="onCheckCode(scope.row)" effect="dark" placement="top" :content="onCheckCode(scope.row)">
                        <span class="icon el-icon-warning" style="display: inline-block; color: #ffba00; margin-left: 5px"></span>
                    </el-tooltip>
                </div>
            </template>
        </el-table-column>
        <el-table-column key="iteM_NAM" prop="iteM_NAM" label="收支項目" min-width="120" sortable>
            <template slot-scope="scope">
                {{ scope.row.iteM_NAM || "--" }}
            </template>
        </el-table-column>
        <el-table-column key="sigN_STS" prop="sigN_STS" label="來源帳務狀態" width="130" sortable>
            <template slot-scope="scope">
                <PaymentStatusLabel v-if="!scope.row.taxCredited" :statusNum="scope.row.sigN_STS" />
                <span v-else>--</span>
            </template>
        </el-table-column>

        <el-table-column key="beforeTax" prop="beforeTax" label="銷售額(未稅)" align="right" width="120" sortable>
            <template slot-scope="scope">
                <Money :v="scope.row.amt - scope.row.tax" />
            </template>
        </el-table-column>
        <el-table-column key="tax" prop="tax" label="稅額" align="right" width="100" sortable>
            <template slot-scope="scope">
                <Money :v="scope.row.tax" />
            </template>
        </el-table-column>
        <el-table-column key="amt" prop="amt" label="含稅金額" align="right" width="120" sortable>
            <template slot-scope="scope">
                <Money :v="scope.row.amt" />
            </template>
        </el-table-column>
        <el-table-column key="companyName" prop="companyName" label="賣方公司" min-width="115" :show-overflow-tooltip="true" sortable></el-table-column>
        <el-table-column key="bsn" prop="bsn" label="賣方統編" width="110" sortable></el-table-column>
        <el-table-column key="dat" prop="dat" label="請款單日期" width="115" sortable>
            <template slot-scope="scope">
                {{ scope.row.dat | dateFormater("YYYY-MM-dd") }}
            </template>
        </el-table-column>
        <!-- <el-table-column key="sourceType" prop="sourceType" label="來源" width="110" sortable>
            <template slot-scope="scope">
                <span>
                    {{ scope.row.taxCredited ? "外部進項發票" : "請款單" }}
                </span>
            </template>
        </el-table-column> -->
        <el-table-column key="ioo" prop="ioo" label="來源請款單" width="115" sortable>
            <template slot-scope="scope">
                <el-button v-if="!scope.row.taxCredited" type="text" @click="$emit('open', scope.row.paySno)">{{ scope.row.payoo }}</el-button>
                <span v-else-if="scope.row.taxCredited">{{ scope.row.customNumber }}</span>
                <span v-else>--</span>
            </template>
        </el-table-column>
    </el-table>
</template>

<script>
import _ from 'lodash';
import moment from 'moment';
import { mapState, mapMutations, mapActions } from 'vuex';
import { attachmentTypes } from '@/assets/commonData/options';
import ahReceiptNumber from '@/components/ui/ahReceiptNumber.vue';
import PaymentStatusLabel from '@/components/dashboard/Payment/PaymentStatusLabel.vue';
import invoiceSerialNumber from '@/assets/commonData/invoiceSerialNumber';
import { paymentCodeOptions } from './CodeOptions';

export default {
    components: { ahReceiptNumber, PaymentStatusLabel },
    props: {
        showPeriod: {
            type: Boolean,
            default: true,
        },
    },
    data() {
        return {
            tableHeight: 0,
            tableKey: 1,
        };
    },
    computed: {
        ...mapState({
            periodList: (state) => state.businessTax.periodList,
            isLoading: (state) => state.businessTax.isLoading,
            data: (state) => state.businessTax.datas,
            queryParams: (state) => state.businessTax.queryParams,
            selectedItems: (state) => state.businessTax.selectedItems,
            declaredPaymentItems: (state) => state.businessTax.declaredPaymentItems,
        }),
        codeOptions() {
            return paymentCodeOptions;
        },
        emptyText() {
            return this.declaredPaymentItems.length && !this.data.length ? '本期已申報完畢' : '本期無資料';
        },
    },
    methods: {
        ...mapMutations({
            setCurrentTableVueComponent: 'businessTax/setCurrentTableVueComponent',
            onSelect: 'businessTax/onSelect',
            onSelectAll: 'businessTax/onSelectAll',
        }),
        ...mapActions({
            updateData: 'businessTax/updateData',
        }),
        isStatusChangeable(row) {
            return row.filE_TYP === 1 || row.filE_TYP === 2 || row.filE_TYP === 3 || row.filE_TYP === 10 || row.filE_TYP === 11;
        },
        resizeTableLayout() {
            const pageHeight = Math.max(document.documentElement.clientHeight, window.innerHeight || 0);
            const tableY = this.$refs.table.$el.getBoundingClientRect().top;
            const tableHeight = pageHeight - tableY - 50;
            this.tableHeight = tableHeight;
        },
        isExportable(row) {
            return !(!row.bsn || !row.foo);
        },
        getAttachmentTextByKey(key) {
            return _.find(attachmentTypes, ['key', key])?.value;
        },

        // ======================== 新增Function =============================

        getDeclaredText(row) {
            if (this.isStatusChangeable(row)) {
                if (!row.declareStatus) return '未申報';
                return row.declareStatus === 1 ? '已申報' : '不申報扣抵';
            }

            return '不能申報';
        },

        // ======================== DataTableMixins =============================
        fetchSelection(sel) {
            sel.forEach((item) => {
                const SEL = _.find(this.data, (o) => o.sno === item.sno && o.typ === item.typ);
                if (SEL) {
                    this.$nextTick(() => {
                        this.$refs.table.toggleRowSelection(SEL);
                    });
                }
            });
        },
        onSortChange(event) {
            this.$emit('onSortChange', event);
        },
        getPeriodText(year, month) {
            const PERIOD_OBJECT = _.find(this.periodList, { year, value: month });
            return PERIOD_OBJECT ? `${PERIOD_OBJECT.year - 1911}年 ${PERIOD_OBJECT.period}` : '尚未申報';
        },
        checkNumberDuplicate(row) {
            if (!row.foo) return false;
            return _.find(this.data, (o) => o.sno !== row.sno && o.foo === row.foo);
        },
        isCodeAvailable(row) {
            // if (!row.typ && row.declareStatus === 1) return false;
            // if (row.typ > 0 && row.declared) return false;
            // if (row.typ < 0 && row.foO_DIS_Declared) return false;
            // if (this.selectedItems.find((o) => o.declared || o.declareStatus === 1)) return !this.selectedItems.includes(row);
            return true;
        },
        onCheckCode(item) {
            const validateCode = this.getValidateCode(item);
            if (validateCode) {
                // eslint-disable-next-line eqeqeq
                const validate = item.code == validateCode;
                return validate ? undefined : '與要求之格式代號不符，請確認發票日期、字軌號碼是否正確。';
            }

            return '本期查無對應發票字軌，請確認發票日期、字軌號碼是否正確。';
        },
        onCheckType(item) {
            // 格式代號和發票字軌不符時，不檢查格式代號與自選類型對應
            if (this.onCheckCode(item)) return true;

            const isIncome = item.ioo || item.tioo;
            const CODE = +item.code;
            if (isIncome) {
                switch (CODE) {
                case 31:
                case 35:
                    return item.typ === 3;
                case 32:
                    return item.typ === 2;
                default:
                    return false;
                }
            } else {
                switch (CODE) {
                case 21:
                    return item.filE_TYP === 3;
                case 22:
                    return item.filE_TYP === 11 || item.filE_TYP === 2;
                case 25:
                    return item.filE_TYP === 1 || item.filE_TYP === 10;
                default:
                    return false;
                }
            }
        },
        getValidateCode(item) {
            if (item.typ < 0) return undefined;
            if (item.filE_TYP === 11) return 22;

            const isIncome = item.typ !== undefined;
            const fooMonth = moment(item.foO_DAT).month() + 1;
            const fooYear = moment(item.foO_DAT).year();
            const fooKey = `${item.foo[0]}${item.foo[1]}`;
            const TYPE = _.chain(invoiceSerialNumber)
                .filter(['year', fooYear])
                .find((o) => o.month.includes(fooMonth))
                .get('datas')
                .find((o) => o.serialNumbers.includes(fooKey))
                .get('name')
                .value();

            const isCashierTripleInvoice = item.filE_TYP === 10;
            const TYPE_CODE = { A: 1, B: 2, D: 5 };
            if (TYPE) {
                return `${isIncome ? 3 : 2}${isCashierTripleInvoice ? 5 : TYPE_CODE[TYPE]}`;
            }
            return undefined;
        },
        async onItemCodeInput(sno, code, isTCIN) {
            try {
                // 發送更新Api
                if (isTCIN) {
                    const resp = await this.$api({
                        url: 'AccountingSummaryPage/UpdatePayInvoice401Code',
                        data: {
                            updateType: this.queryParams.QueryType,
                            code401s: [{ sno, code }],
                        },
                        method: 'POST',
                    });
                    console.log('UpdateTCIN401Code', resp);
                } else {
                    const resp = await this.$api({
                        url: 'AccountingSummaryPage/Update401Code',
                        data: {
                            updateType: this.queryParams.QueryType,
                            code401s: [{ sno, code }],
                        },
                        method: 'POST',
                    });
                    console.log('Update401Code', resp);
                }

                // 更新LocalStorage
                const LOCAL_DATA_NAME = this.queryParams.QueryType === 1 ? '401-selected-invoice' : '401-selected-payment';
                const LOCAL_DATA = JSON.parse(window.localStorage.getItem(LOCAL_DATA_NAME)) || [];
                const FOUND_INDEX = _.findIndex(LOCAL_DATA, ['sno', sno]);

                if (FOUND_INDEX >= 0) {
                    const dataChanged = LOCAL_DATA[FOUND_INDEX];
                    dataChanged.code = code;
                    window.localStorage.setItem(LOCAL_DATA_NAME, JSON.stringify(LOCAL_DATA));
                }

                // 更新列表
                this.updateData();
            } catch (e) {
                console.log(e);
            }
        },

        getIndex(val) {
            return this.queryParams.PageSize * (this.queryParams.PageNum - 1) + val + 1;
        },
    },
    mounted() {
        this.setCurrentTableVueComponent(this);

        this.resizeTableLayout();
        setTimeout(() => {
            this.tableKey += 1;
            this.$refs.table.key = this.tableKey;
        }, 1);
        window.addEventListener('resize', this.resizeTableLayout);
    },
    beforeDestroy() {
        window.removeEventListener('resize', this.resizeTableLayout);
    },
};
</script>

<style lang="scss" scoped>
@import "./common-style.scss";
</style>
